module.exports = __webpack_public_path__ + "static/006-e4b71c5dbddffbe6c4db93d40ebb34ed.jpg";